module.exports = __webpack_public_path__ + "jab/media/dialogue.9d6c6cfc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/dialogue.svg
// module id = 1474
// module chunks = 0